export default __webpack_public_path__ + "d08d63fcb933d961d7a256f396688959.png";